import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ChartSaleHorizontalBar from './ChartSaleHorizontalBar';

const PopularProductsCharts = ({ data = {}, topN = 6, currency = '' }) => {
  const { t } = useTranslation();

  const {
    itemsByCount = { labels: [], values: [] },
    itemsByProfit = { labels: [], values: [] },
    categoriesByCount = { labels: [], values: [] },
    categoriesByProfit = { labels: [], values: [] }
  } = data || {};

  const sliceTop = (arr) => (Array.isArray(arr) ? arr.slice(0, topN) : []);

  const itemsCountLabels = sliceTop(itemsByCount.labels);
  const itemsCountValues = sliceTop(itemsByCount.values);

  const itemsProfitLabels = sliceTop(itemsByProfit.labels);
  const itemsProfitValues = sliceTop(itemsByProfit.values);

  const categoriesCountLabels = sliceTop(categoriesByCount.labels);
  const categoriesCountValues = sliceTop(categoriesByCount.values);

  const categoriesProfitLabels = sliceTop(categoriesByProfit.labels);
  const categoriesProfitValues = sliceTop(categoriesByProfit.values);

  const noData =
    !itemsCountValues.length &&
    !itemsProfitValues.length &&
    !categoriesCountValues.length &&
    !categoriesProfitValues.length;

  if (noData) {
    return (
      <div className="p-3 bg-white">
        <h5>{t('statistic.noData')}</h5>
      </div>
    );
  }
  return (
    <Row className="gy-4 gx-4">
      <Col md={6} className='ps-md-0'>
        <h4 className="fs-3 text-dark mb-4 pb-2">{t('salesStatistics.Popular products by sales quantity')}</h4>
        <ChartSaleHorizontalBar
          label={t('salesStatistics.Popular products by sales quantity')}
          labels={itemsCountLabels}
          dataCounts={itemsCountValues}
          color="#EEECF8"
          borderColor="#5842BE"
          tooltipLabel='salesStatistics.Sales count'
        />
      </Col>

      <Col md={6} className='pe-md-0'>
        <h4 className="fs-3 text-dark mb-4 pb-2">{t('salesStatistics.Popular categories by sales quantity')}</h4>
        <ChartSaleHorizontalBar
          label={t('salesStatistics.Popular categories by sales quantity')}
          labels={categoriesCountLabels}
          dataCounts={categoriesCountValues}
          color="#E8F7F4"
          borderColor="#1AB394"
          tooltipLabel='salesStatistics.Sales count'
        />
      </Col>

      <Col md={6} className='ps-md-0 pt-md-4'>
        <h4 className="fs-3 text-dark mb-4 pb-2">{t('salesStatistics.Popular products by profit amount')}</h4>
        <ChartSaleHorizontalBar
          label={t('salesStatistics.Popular products by profit amount')}
          labels={itemsProfitLabels}
          dataCounts={itemsProfitValues}
          color="#FBEFF6"
          borderColor="#EA89C2"
          currency={currency}
          tooltipLabel='salesStatistics.Profit'
        />
      </Col>

      <Col md={6} className='pe-md-0 pt-md-4'>
        <h4 className="fs-3 text-dark mb-4 pb-2">{t('salesStatistics.Popular categories by profit amount')}</h4>
        <ChartSaleHorizontalBar
          label={t('salesStatistics.Popular categories by profit amount')}
          labels={categoriesProfitLabels}
          dataCounts={categoriesProfitValues}
          color="#FEF7EE"
          borderColor="#F8AC59"
          currency={currency}
          tooltipLabel='salesStatistics.Profit'
        />
      </Col>
    </Row>
  );
};

export default PopularProductsCharts;
